// US phone mask: progressive (###) ###-#### as the user types. Idempotent.
export function maskPhone(val) {
  let d = String(val || "").replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  d = d.slice(0, 10);
  if (d.length === 0) return "";
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

const PHONE_RE = /phone|fax|mobile|cell/i;
export function isPhoneField(f) {
  const key = `${f?.name || ""} ${f?.label || ""}`;
  return PHONE_RE.test(key);
}
